/*
 * Module for the Max Drop Participation report criteria page
 */
rs.module("content/reports/maxdropparticipationcriteria",

    ["common/select-helper"],

    function (selectHelper) {
        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var sortByDropDown = criteria.js(jsSelectors.sortSelect);
            var sortDirectionDropDown = criteria.js(jsSelectors.sortDirectionSelect);

            // Get Select Helper for sortDirectionDropDown since we're updating its options and properties
            var sortDirectionSelectHelper = selectHelper.getHelper(sortDirectionDropDown);

            sortByDropDown.ready(function () {
                setDirectionDropDown();
            });

            // disable the detail dropdown based on the status of 
            sortByDropDown.change(function () {
                setDirectionDropDown();
            });

            //Set the disabled property on the sortByDropDown
            function setDirectionDropDown() {

                if (sortByDropDown.val() == "MemberName") {
                   sortDirectionSelectHelper.setValue("ASC");
                   sortDirectionSelectHelper.setDisabled(true);                  
                }
                else {
                   sortDirectionSelectHelper.setDisabled(false);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);